module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "bg-gray"
  }, [_c('div', {
    staticClass: "form-content"
  }, [_c('el-divider', [_vm._v(_vm._s(_vm.$T('住宿预订')))]), _vm._v(" "), _c('div', {
    staticClass: "actions"
  }, [_c('el-button', {
    attrs: {
      "type": "primary",
      "icon": "el-icon-plus"
    },
    on: {
      "click": _vm.addBookingRow
    }
  }, [_vm._v(_vm._s(_vm.$T('添加房间')))])], 1), _vm._v(" "), _c('el-table', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.bookingList,
      "border": "",
      "stripe": "",
      "size": "mini",
      "empty-text": _vm.$T('暂无数据')
    }
  }, [_c('el-table-column', {
    attrs: {
      "type": "index",
      "width": "50",
      "label": _vm.$T('序号')
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": _vm.$T('预订酒店'),
      "min-width": "200"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-select', {
          staticStyle: {
            "width": "100%"
          },
          attrs: {
            "placeholder": _vm.$T('请选择酒店'),
            "clearable": ""
          },
          on: {
            "change": function($event) {
              return _vm.onHotelChange(scope.row)
            }
          },
          model: {
            value: (scope.row.hotel_id),
            callback: function($$v) {
              _vm.$set(scope.row, "hotel_id", $$v)
            },
            expression: "scope.row.hotel_id"
          }
        }, _vm._l((_vm.hotelOptions), function(hotel) {
          return _c('el-option', {
            key: hotel.id,
            attrs: {
              "label": hotel.title,
              "value": hotel.id
            }
          })
        }), 1)]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": _vm.$T('房型'),
      "min-width": "180"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-select', {
          staticStyle: {
            "width": "100%"
          },
          attrs: {
            "placeholder": _vm.$T('请选择房型'),
            "clearable": ""
          },
          on: {
            "change": function($event) {
              return _vm.onRoomTypeChange(scope.row)
            }
          },
          model: {
            value: (scope.row.room_type_id),
            callback: function($$v) {
              _vm.$set(scope.row, "room_type_id", $$v)
            },
            expression: "scope.row.room_type_id"
          }
        }, _vm._l((_vm.getRoomTypeByHotel(scope.row.hotel_id)), function(roomType) {
          return _c('el-option', {
            key: roomType.id,
            attrs: {
              "label": roomType.name,
              "value": roomType.id
            }
          })
        }), 1)]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": _vm.$T('入住日期'),
      "min-width": "150"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-date-picker', {
          staticStyle: {
            "width": "100%"
          },
          attrs: {
            "type": "date",
            "value-format": "yyyy-MM-dd",
            "picker-options": _vm.checkinPickerOptions(scope.row)
          },
          on: {
            "change": function($event) {
              return _vm.onCheckinChange(scope.row)
            }
          },
          model: {
            value: (scope.row.checkin_date),
            callback: function($$v) {
              _vm.$set(scope.row, "checkin_date", $$v)
            },
            expression: "scope.row.checkin_date"
          }
        })]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": _vm.$T('退房日期'),
      "min-width": "150"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-date-picker', {
          staticStyle: {
            "width": "100%"
          },
          attrs: {
            "type": "date",
            "value-format": "yyyy-MM-dd",
            "picker-options": _vm.checkoutPickerOptions(scope.row)
          },
          model: {
            value: (scope.row.checkout_date),
            callback: function($$v) {
              _vm.$set(scope.row, "checkout_date", $$v)
            },
            expression: "scope.row.checkout_date"
          }
        })]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": _vm.$T('数量'),
      "min-width": "110"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-input', {
          staticClass: "qty-input",
          attrs: {
            "type": "number",
            "min": "1"
          },
          on: {
            "change": function($event) {
              return _vm.normalizeQuantity(scope.row)
            }
          },
          model: {
            value: (scope.row.quantity),
            callback: function($$v) {
              _vm.$set(scope.row, "quantity", _vm._n($$v))
            },
            expression: "scope.row.quantity"
          }
        })]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": _vm.$T('价格'),
      "min-width": "120"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('span', [_vm._v(_vm._s(Number(scope.row.price || 0).toFixed(2)) + " USD")])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": _vm.$T('操作'),
      "width": "100",
      "fixed": "right"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-button', {
          staticStyle: {
            "color": "#f56c6c"
          },
          attrs: {
            "type": "text"
          },
          on: {
            "click": function($event) {
              return _vm.removeBookingRow(scope.$index)
            }
          }
        }, [_vm._v(_vm._s(_vm.$T('删除')))])]
      }
    }])
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "summary"
  }, [_c('span', [_vm._v(_vm._s(_vm.$T('总数量')) + ": " + _vm._s(_vm.totalQuantity))]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.$T('总价')) + ": " + _vm._s(_vm.totalPrice.toFixed(2)) + " USD")])]), _vm._v(" "), _c('div', {
    staticClass: "footer-button"
  }, [_c('el-button', {
    attrs: {
      "type": "primary",
      "loading": _vm.saveLoading
    },
    on: {
      "click": _vm.onNextStep
    }
  }, [_vm._v(_vm._s(_vm.$T('下一步')))])], 1)], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-59ace7bc","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/page/apps/isai/SaiApplyFormStep3.vue
// module id = 1429
// module chunks = 0